var App = App || {};

App.SiteCookieNotice = (function ($) {
    'use strict';

    function init() {

        var Notice = $(".site-cookie-notice");
        var Confirm = Notice.find("[data-cookieNotice='confirm']");

        Confirm.click(function () {
            Notice.slideUp(200);
            App.Cookies.setItem("AppleBank_CookieNotice", "confirmed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteCookieNotice.init();
});